// Blog Module - Load More Functionality
jQuery(document).ready(function($) {
    console.log('Blog Module JS loaded');
    
    // Test-Funktion
    $('.load-more-btn').on('click', function(e) {
        e.preventDefault();
        console.log('Load more button clicked');
    });
});
